<script lang="ts">
  import * as _ from "lodash";
  import { iconLookup } from "@shared/svelte/Modules/IconLookup.svelte";

  export let type;
  export let width = null;
  export let height = null;
  export let className;
  export let extraClassNames = "";
  export let onPress = null;
  export let color: string = null;
  export let fill: string = "currentColor";
  export let transform: string = null;
  export let centered = false;
  export let extraStyles: string = "";
  export let opacity = 1;
  export let id: string = null;
  export let dataTestId: string = null;

  function iconClass() {
    return (className || "") + " svg-icon" + " " + extraClassNames;
  }

  function svgStyle() {
    let styles = `opacity: ${opacity}; `;
    if (color) {
      styles += `color: ${color}; `;
    }
    if (fill) {
      styles += `fill: ${fill} !important; `;
    }
    if (height && width) {
      styles += `height: ${height}px; width: ${width}px; `;
    }
    if (transform) {
      styles += `transform: ${transform};`;
    }
    if (centered) {
      styles += `margin-left: auto; margin-right:auto;`;
    }
    return styles;
  }

  function onPressWrapper(event) {
    if (onPress) {
      onPress(event);
    }
  }
  let svgStyleValue = svgStyle();
  let iconClassValue = iconClass();
  let iconComponent = iconLookup(type);
  if (!iconComponent && window["C"]?.env !== "test") {
    console.error(`Icon ${type} not found`);
  }

  $: {
    color = color;
    className = className;
    svgStyleValue = svgStyle();
    iconClassValue = iconClass();
    iconComponent = iconLookup(type);
  }
</script>

{#if iconComponent}
  <span on:click={onPressWrapper} on:keydown={onPressWrapper}>
    <svelte:component
      this={iconComponent}
      role="img"
      style={`${svgStyleValue} ${extraStyles}`}
      class={iconClassValue}
      {id}
      data-testid={dataTestId || id}
    />
  </span>
{/if}
